import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const InsuranceCoverage = ({ roles }) => {

    return (
        <M_Table entityName={'InsuranceCoverage'} filtersOnTable rolePermissions={roles} />
    )
}